import React from 'react';
import { compose } from 'redux';
import { withOktaAuth } from '@okta/okta-react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { checkAnalyticsAccess } from '../../actions';
//import HeaderFilterBs from './HeaderFilterBs';



class AnaltyicsHeader extends React.Component {

    checkUserAccess = async () => {

        if (this.props.authState.isAuthenticated) {
            let authObj = {};
            const userInfo = await this.props.oktaAuth.getUser();
            authObj.curUserInfo = userInfo;
            authObj.token = this.props.authState.accessToken;
            //Action to check if user has analytics access
            await this.props.checkAnalyticsAccess(authObj.token);

        }
    }

    componentDidMount() {
        if (Object.keys(this.props.user).length === 0) {
            this.checkUserAccess();
        }
    }

    render() {
        let updatedTime = new Date();
        updatedTime = updatedTime.toString();
        // eslint-disable-next-line
        updatedTime = updatedTime.replace(/GMT.*/g, "");

        //edge case if undefined
        if (this.props.hasAnalyticsAccess === undefined) {
            console.log("Loading!!!")
            return null;
        }
        //if user doesn't have access redirect them
        else if (this.props.hasAnalyticsAccess === false) {
            console.log("DON'T ALLOW USER TO VIEW ANALYTICS");
            this.props.history.push('/');
        } else {
            console.log("User has permission to view analytics");
        }

        return (
            <div className="main-header" style={{ fontFamily: "interBoldUI" }}>
                {/* <!-- Logo Header --> */}
                <div className="logo-header" data-background-color="white" >
                    <a href="/" className="logo" id='logoHeader'>
                        <img src="../../../assets/img/intuitive_logo_black.png" alt="navbar brand" className="navbar-brand"></img>
                    </a>
                </div>
                <nav className="navbar navbar-header navbar-expand-lg" data-background-color="white">
                    <div className='container-fluid'>
                        <h2 className="text-black pb-2 fw-bold" id='appName'>Analytics</h2>
                        <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                            <li className="nav-item dropdown hidden-caret">
                                {/* <a class="nav-link dropdown-toggle" href="#" id="notifDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <small className="text-muted" id="updateTimeText" >Updated: Fri Dec 15 2023</small>
                                </a> */}
                                <small className="text-muted" id="updateTimeText" >Updated: {updatedTime}</small>
                            </li>
                            <li className="nav-item dropdown hidden-caret submenu show">
                                <a className="dropdown-toggle profile-pic" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <div className="avatar-sm">
                                        <img src="/assets/img/profile_placeholder.png" alt="..." className="avatar-img rounded-circle"></img>
                                    </div>
                                </a>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a className="dropdown-item" href="/">Home</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return { hasAnalyticsAccess: state.analyticsAccess, user: state.user };
}

export default compose(withRouter, withOktaAuth, connect(mapStateToProps, { checkAnalyticsAccess }))(AnaltyicsHeader);